/**
 * 
 * @name = Private Routes
 * @description = Private Routes vary based on the Apps, For example, 
 * Dashboard, User Profile, App Settings, Home etc. In simple words, 
 * These routes can be accessed only after login.
 * 
 * @author = Naveen Kumar
 * @since = 07 Oct, 2021
 * 
 */

import React, { useEffect, useRef } from 'react';
import { Route } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PageContentHolder from '../components/PageContentHolder';
import './Routes.scss';
import CustomAlertContainer from '../components/CustomAlertContainer';
import { isServer } from '../helpers/server.helper';
import { getIsHosted, history, SaveLocal } from '../helpers';
import { setPage } from '../redux/actions';
import BaseLayout from '../components/BaseLayout';
import { ALLOWED_ECOSYSTEM_MPID } from '../constants/app.constants';
import { useLocation } from 'react-router-dom';



const usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
};

const PrivateRoute = ({ mobileView, children, mainRef, ...rest }) => {
    const { app } = useSelector(state => state);
    const props = { children, ...rest };
    const prevLocationPathname = usePrevious(props?.location?.pathname);
    const isErrorRoute = app?.page?.key === 'nf' || app?.page?.key === "um" || app?.page?.key === "qr" ? true : false;
    const dispatch = useDispatch();
    const location = useLocation();
    const queryString = new URLSearchParams(location?.search && !isServer ? location?.search : "");

    const isHosted = getIsHosted(queryString);  //key to show the web app header and footer

    useEffect(() => {
        if (prevLocationPathname !== props?.location?.pathname) {
            !isServer && window?.scrollTo(0, 0);
        }
    }, [props?.location?.pathname, prevLocationPathname]);

    useEffect(() => {
        const currentPage = history?.location?.state?.page;
        if (currentPage) {
            dispatch(setPage(JSON.parse(currentPage)));
        }
    }, [history?.location?.pathname])

    return (
        <>
            <Route
                {...rest}
                render={
                    ({ location }) =>
                        <>
                            {/* <TopNavigation /> */}
                            <div className={"privateRoute"}>
                                {
                                    ALLOWED_ECOSYSTEM_MPID.includes(app?.meetingPlace?.mpid) && isHosted==='true' ? 
                                    <BaseLayout>
                                        <main id={'main-content'} style={{"margin-top": mobileView ? '80px' : '130px'}} ref={mainRef} tabIndex={-1}>
                                            <PageContentHolder topMenu={app?.page?.topMenu}>
                                                {children}
                                            </PageContentHolder>
                                        </main>
                                    </BaseLayout>
                                    :
                                        <>
                                            {!mobileView && <Header topMenu={app?.page?.topMenu} isExternalRoute={isErrorRoute} />}
                                            <main id={'main-content'} ref={mainRef} tabIndex={-1}>
                                                <PageContentHolder topMenu={app?.page?.topMenu}>
                                                    {children}
                                                </PageContentHolder>
                                            </main>
                                            {!mobileView && <Footer topMenu={app?.page?.topMenu} />}
                                        </>
                                }

                            </div>
                            <CustomAlertContainer></CustomAlertContainer>
                        </>
                }
            />
            {/* <Redirect path="*" to='/404' /> */}
        </>
    );
}

export default PrivateRoute;
